import React from "react";
import { Plus } from "lucide-react";

const ActionButton = ({
    onClick,
    text = "Nuevo",
    icon = <Plus size={12} strokeWidth={2.5} />,
    color = "primary",
    disabled = false,
    className = "",
}) => {

    const colors = {
        primary:
            "text-blue-600 hover:text-blue-800 hover:bg-blue-50",

        success:
            "text-green-600 hover:text-green-800 hover:bg-green-50",

        danger:
            "text-red-600 hover:text-red-800 hover:bg-red-50",

        gray:
            "text-gray-600 hover:text-gray-800 hover:bg-gray-100",
    };

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={`
                flex
                items-center
                gap-2
                font-semibold
                py-1
                px-4
                rounded-lg
                shadow-sm
                transition-all
                duration-300
                disabled:opacity-50
                disabled:cursor-not-allowed
                ${colors[color]}
                ${className}
            `}
        >
            {icon}

            <span className="capitalize">
                {text}
            </span>
        </button>
    );
};

export default ActionButton;